module.exports = __webpack_public_path__ + "img/16.3b9ac820.webp";